import React, { useState } from "react";
import { Form, Col } from "react-bootstrap";
import { BfButtonBlue, BfButtonBlueSecondary } from "../../../Styling/styledForm/styledBlueForm";
import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,
} from "../../../Styling/styledModal/styledModals";
import _ from 'lodash'

const SvarMeldingModal = (props) => {

    const localeMessages = props.localeMessages
    const model = props.model

    const [noteText, setNoteText] = useState('')
    const [selectedUploadFile, setselectedUploadFile] = useState(null)

    const onUploadFileChange = event => {
        console.log(event.target.files[0])
        setselectedUploadFile(event.target.files[0])
    };

    const validates = () => (noteText) ? '' : 'disabled'

    const handleOk = () => {

        const resultModel = {
            ...model,
            noteText: noteText,
            selectedUploadFile: selectedUploadFile
        }
        
        props.ok(resultModel)
    }

    const handleCancel = () => {
        props.close()
    }

    const messageLfCorrected = () => {
        if (model.messageText) {
            return model.messageText.replaceAll('\\r\\n', '\n')
        }
        else return ''
    }

    return (

        <StyledModal centered show={true} onHide={handleCancel} size="xl">

            <StyledModalBody>
                <h4>{localeMessages["MS1M_Overskrift"]}</h4>
                <Form.Group>

                    <Form.Label column="sm" lg={2}>
                        {localeMessages["MS1M_sak"]}
                    </Form.Label>
                    <Col>
                        {model.caseNo} {model.debtorName}
                    </Col>

                    <Form.Label column="sm" lg={2}>
                        {localeMessages["MS1M_melding"]}
                    </Form.Label>
                    <Col>
                        
                        <Form.Control id="Oppgave" name="meldingstekst" as="textarea" rows={8} readOnly style={{ backgroundColor: '#ffd7ba', whiteSpace: 'pre-line'}}
                            value={messageLfCorrected()}
                        />
                    </Col>

                    <div>&nbsp;</div>


                    <Form.Label column="sm" lg={2}>
                        {localeMessages["MS1M_svar"]}
                    </Form.Label>
                    <Col>
                        <Form.Control id="Oppgave" name="Oppgave" as="textarea" rows={8} 
                            value={noteText}
                            onChange={(e) => setNoteText(e.target.value)}
                        />
                    </Col>

                    <div>&nbsp;</div>                 

                    <Form.Label column="sm" lg={2}>

                    </Form.Label>
                    <Col>
                        <input type="file" onChange={onUploadFileChange} />
                    </Col>

                </Form.Group>

            </StyledModalBody>

            <StyledModalFooter>
                <BfButtonBlue
                    disabled={validates()}
                    onClick={handleOk}
                >
                    {localeMessages["MS1M_Ok"]}
                </BfButtonBlue>
                <BfButtonBlueSecondary textAsBorder blackBorder 
                    onClick={handleCancel}
                >
                    {localeMessages["MS1M_Avbryt"]}
                </BfButtonBlueSecondary>

            </StyledModalFooter>

        </StyledModal>
    );
};

export default SvarMeldingModal;

